import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import { getClassSet, splitBsProps } from './utils/bootstrapUtils';
import { jsx as _jsx } from "react/jsx-runtime";
function ModalTitle(_ref) {
  let {
    componentClass: Component = 'h4',
    className,
    bsClass = 'modal-title',
    ...props
  } = _ref;
  const [bsProps, elementProps] = splitBsProps({
    ...props,
    bsClass
  });
  const classes = getClassSet(bsProps);
  return /*#__PURE__*/_jsx(Component, {
    ...elementProps,
    className: clsx(className, classes)
  });
}
export default ModalTitle;